var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartialllyaccepted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.1 47.1",
    style: {
      enableBackground: "new 0 0 47.1 47.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#425EAB;stroke-width:3;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#425EAB;stroke-width:3;stroke-linecap:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.5,
    cy: 23.5,
    r: 21.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.2,
    y1: 37.6,
    x2: 39.8,
    y2: 9.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 7.2,
    y1: 37.6,
    x2: 39.3,
    y2: 37.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 29.8,
    y1: 18.1,
    x2: 44.4,
    y2: 18.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 14.8,
    y1: 31.1,
    x2: 43.4,
    y2: 31.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 22.3,
    y1: 24.6,
    x2: 45,
    y2: 24.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialllyaccepted);
export default __webpack_public_path__ + "static/media/partiallly accepted.14fbeb50c5932f103c4968eb00628f33.svg";
export { ForwardRef as ReactComponent };